import { render, staticRenderFns } from "./MultiEmailInput.vue?vue&type=template&id=87a4ead8&"
import script from "./MultiEmailInput.vue?vue&type=script&lang=js&"
export * from "./MultiEmailInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultiEmailInput.vue"
export default component.exports